import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { BoardContextValue } from '../board/useBoardContext';
import { AiTabbedModal } from '../board/ai';
import { SparkleIcon } from './icons';
import '@/styles/ai.css';

export interface AiAssistantProps {
  context: BoardContextValue;
  /** Callback khi import câu hỏi thành công - báo kết quả cho vỏ bảng */
  onOpenLibrary?: (highlightIds: string[], openedOnBoard: boolean) => void;
}

// bottom-left of the canvas; it rides above the keyboard inset so the thumb never loses it
export function AiAssistant({ context, onOpenLibrary }: AiAssistantProps) {
  const { t } = useTranslation('ai');
  const [open, setOpen] = useState(false);

  return (
    <div className="ai-fab-slot">
      <button
        type="button"
        className="ai-fab"
        aria-label={t('assistant.open')}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <SparkleIcon size={22} />
      </button>
      <AiTabbedModal open={open} context={context} onClose={() => setOpen(false)} onImportSuccess={onOpenLibrary} />
    </div>
  );
}
